import React, { FC, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import { useCceDetailModel } from "./cceDetailModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { Button, message } from "antd";
import { getFormValidatorErrText } from "@/utils/utils";
import { ValidateErrorEntity } from "rc-field-form/es/interface";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";

export const TopButs: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const { editFormVal, insertOrUpdateCce, getCceDetailOne, resetPageCache } = useCceDetailModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel(({ selectedNavId }) => [selectedNavId]);

    useEffect(() => {
        if (!editFormVal.id && mode === "edit") {
            getCceDetailOne(id)
        }
    }, [mode]);

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav("10-1-1") && resetPageCache("add")
            !findNav("10-1-2") && resetPageCache("edit");
        }
    }, [selectedNavId])

    const orderStatu: IDescription[] = [
        {
            label: "编号",
            value: editFormVal.code ?? "无",
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: "???",
            // value: getTreeNodeName(editFormVal.status ?? ""),
            color: DescriptionColorEnum.green,
            status: true
        },
        // {
        //     label: "状态",
        //     value: getTreeNodeName(editFormVal.status ?? ""),
        //     color: DescriptionColorEnum.green,
        //     status: true
        // },
    ]


    //表单提交
    const onSubmit = () => {
        formRef.current?.validateFields().then((val: any) => {
            insertOrUpdateCce(mode).then(res => {
                if (mode === "add" && res) {
                    resetPageCache("edit");
                    replaceNav("10-1-1", "10-1-2", { id: res as string, mode: "edit" });
                }
            })
        }).catch((err: ValidateErrorEntity<any>) => {
            message.warning(getFormValidatorErrText(err));
        })
    };

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.L_A_ED_SAVE}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { onSubmit() }}
            >保存</Button>
        </YhAuth>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => replaceNav(selectedNavId, "10-1")}
        >返回</Button>
    </>


    return (
        <YhBox
            // title={orderStatu.map((item, index) => <Description key={index} {...item} />)}
            style={{ paddingBottom: 0, marginBottom: "10px" }}
            action={action}
        />
    )
}